import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const ResetPasswordSchema = z
  .object({
    token: z.string({
      required_error: i18nMessage("shared:forms.resetPassword.tokenRequired"),
    }),
    password: z
      .string({
        required_error: i18nMessage("shared:forms.resetPassword.passwordRequired"),
      })
      .min(8, i18nMessage("validation:passwordMinLength")),
    passwordConfirmation: z
      .string({
        required_error: i18nMessage("shared:forms.resetPassword.passwordRequired"),
      })
      .min(8, i18nMessage("validation:passwordMinLength")),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: i18nMessage("validation:passwordsMismatch"),
    path: ["passwordConfirmation"],
  });

export type ResetPasswordFormData = z.infer<typeof ResetPasswordSchema>;
